export default __webpack_public_path__ + "assets/ed7732eb0a04206fe06b342c4c64e616.png";